__turbopack_context__.v({
  "className": "dm_sans_fc4b73c7-module__sQVWvq__className",
});
